import { createFileRoute } from "@tanstack/react-router";

import { useProjectId } from "../../../shell/project";
import { DeployedRobotsPage } from "../../../workspaces/fleet/pages/DeployedRobotsPage";

/** The project's deployed robots: each opens its own page. */
export const Route = createFileRoute("/_console/p/$org/$project/deploy/")({
  component: DeployedRobotsRoute,
});

function DeployedRobotsRoute() {
  return <DeployedRobotsPage projectId={useProjectId()} params={Route.useParams()} />;
}
